module.exports = __webpack_public_path__ + "static/media/facebook.ac8be1dd.svg";